import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ExportInterfaceActivationEmailClient, ExportInterfaceActivationEmailDTO, GenerateActivationEmailsDTO } from 'src/app/base/models/models.swagger.generated';
import { AppErrorMessagesService } from 'src/app/base/services/app-error-messages.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable()
export class ActivationEmailService {

  constructor(
    private activationEmailClient: ExportInterfaceActivationEmailClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private errorMessageService: AppErrorMessagesService
  ) {
  }

  public generateActivationEmails(generateActivationEmailsDTO: GenerateActivationEmailsDTO): Observable<ExportInterfaceActivationEmailDTO[]> {
    this.spinnerService.show();
    return this.activationEmailClient.generateActivationEmails(generateActivationEmailsDTO)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        }),
        catchError((error: any) => {
          this.handleError(error);
          return throwError(() => error);
        }),
      );
  }

  public sendActivationEmail(activationEmailDTO: ExportInterfaceActivationEmailDTO): Observable<void> {
    this.spinnerService.show();
    return this.activationEmailClient.sendActivationEmail(activationEmailDTO)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        }),
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.activation-emails.messages.send-success-title',
            'i18n.domain.export-configuration.activation-emails.messages.send-success-message',
          )
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public sendActivationEmails(activationEmailsDTO: ExportInterfaceActivationEmailDTO[]) {
    this.spinnerService.show();
    return this.activationEmailClient.sendActivationEmails(activationEmailsDTO)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        }),
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.activation-emails.messages.send-success-title',
            'i18n.domain.export-configuration.activation-emails.messages.send-success-message',
          )
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  private handleError(error: any) {
    const apiErrorCode = this.errorMessageService.getApiErrorCode(error);
    let i18nErrorMessage = 'i18n.errors.server-error.message';
    const i18nErrorTitle = 'i18n.errors.server-error.title';
    if (apiErrorCode) {
      i18nErrorMessage = 'i18n.domain.export-configuration.activation-emails.messages.errors.' + apiErrorCode;
    }
    this.toastService.showError(i18nErrorTitle, i18nErrorMessage,
      null, ErrorType.serverError);
  }
}
